import isInViewport from "../../../src/scripts/helpers/is-in-viewport";

export default class HeroText {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.hero-text__section'), el => {
            new HeroText(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.stickySectionTrigger = this.element.querySelector('.hero-text .hero-text-sticky-trigger');

        if (!this.stickySectionTrigger) return;
        this.stickySection = this.element.querySelector('.hero-text-sticky');

        window.addEventListener('scroll', (e) => {
            this.stickySection.classList[!isInViewport(this.stickySectionTrigger) ? 'add' : 'remove']('is-visible');
        });
    }
}
